import { render, staticRenderFns } from "./Entrevista.vue?vue&type=template&id=38b8f6c6"
import script from "./Entrevista.vue?vue&type=script&lang=js"
export * from "./Entrevista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports